import React, { useState } from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'
import EmailVerificationButtonLabel from './EmailVerificationButtonLabel'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Shared screen for both the "I use a different email now" (Flow A) and
// "add backup email" (Flow B) steps: collects an address. Re-auth (password,
// or Google/Apple) is handled separately by ReauthenticationModal when the
// API responds with a 403 reauth_required.
const EmailVerificationEmailPasswordForm = (props) => {
  const {
    title, description, emailLabel, submitLabel, currentEmail, backupEmail, showIllustration,
    duplicateEmailError, submitLoading, errorMessage, onSubmit, onBack, backLabel,
    onSkip, skipLabel, onNeverAskAgain,
  } = props
  const [email, setEmail] = useState('')
  const [validationError, setValidationError] = useState('')
  // checked live against the address as typed (not on submit), so the
  // heads-up about retiring the backup shows before they press the button
  const matchesBackupEmail = !!backupEmail &&
    email.trim().toLowerCase() === backupEmail.toLowerCase()

  function handleEmailChange(e) {
    setEmail(e.target.value)
    // a stale error from the last submit would otherwise hide the notice
    setValidationError('')
  }

  function handleSubmit(e) {
    e.preventDefault()
    const trimmedEmail = email.trim()
    if (!EMAIL_REGEX.test(trimmedEmail)) {
      setValidationError('Please enter a valid email address.')
      return
    }
    if (currentEmail && trimmedEmail.toLowerCase() === currentEmail.toLowerCase()) {
      setValidationError(duplicateEmailError)
      return
    }
    setValidationError('')
    onSubmit({ email: trimmedEmail })
  }

  return (
    <div className='emailVerificationFlow-form'>
      {onBack && (
        <button type='button' className='emailVerificationFlow-backBtn' onClick={onBack}>
          {backLabel || '← Back'}
        </button>
      )}
      {showIllustration && <EmailVerificationEnvelopeIllustration />}
      <div className='emailVerificationFlow-title'>{title}</div>
      {description && (
        <div className='emailVerificationFlow-description'>{description}</div>
      )}
      <form className='emailVerificationFlow-form-main' onSubmit={handleSubmit}>
        <label className='emailVerificationFlow-form-label' htmlFor='emailVerificationFlow-emailInput'>
          {emailLabel || 'Email address'}
        </label>
        <input
          id='emailVerificationFlow-emailInput'
          className='emailVerificationFlow-form-input'
          type='email'
          autoComplete='email'
          value={email}
          onChange={handleEmailChange}
          autoFocus
        />
        {(validationError || errorMessage) && (
          <div className='emailVerificationFlow-error'>{validationError || errorMessage}</div>
        )}
        {matchesBackupEmail && !validationError && (
          <div className='emailVerificationFlow-notice'>
            This is your backup email address. By continuing, you&apos;ll no longer have a backup email address and may want to consider adding a new one.
          </div>
        )}
        <button type='submit' className='btn btn--blue btn--large' disabled={submitLoading}>
          <EmailVerificationButtonLabel label={submitLabel || 'Send me a code'} loading={submitLoading} />
        </button>
      </form>
      {onSkip && (
        <div className='emailVerificationFlow-form-links'>
          {onNeverAskAgain && (
            <button type='button' className='emailVerificationFlow-linkBtn' onClick={onNeverAskAgain}>
              Don&apos;t ask me again
            </button>
          )}
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onSkip}
          >
            {skipLabel || 'Not now'}
          </button>
        </div>
      )}
    </div>
  )
}

EmailVerificationEmailPasswordForm.defaultProps = {
  showIllustration: true,
  duplicateEmailError: 'Please enter a different email address.',
}

export default EmailVerificationEmailPasswordForm
